import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import ReactModal from "react-modal";
import "./index.scss";

var AlertModal =
/** @class */
function (_super) {
  __extends(AlertModal, _super);

  function AlertModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      showModal: true
    };

    _this.handleCloseModal = function () {
      _this.setState({
        showModal: false
      });

      _this.props.onModalClose();
    };

    return _this;
  }

  AlertModal.prototype.render = function () {
    return _jsx("div", {
      children: _jsxs(ReactModal, __assign({
        isOpen: this.state.showModal,
        contentLabel: "\u804A\u5929\u7A97\u53E3",
        className: "alert-modal",
        overlayClassName: "alert-overlay",
        ariaHideApp: false,
        shouldCloseOnEsc: true,
        onRequestClose: this.handleCloseModal,
        shouldFocusAfterRender: true,
        shouldCloseOnOverlayClick: true
      }, {
        children: [_jsx("span", {
          onClick: this.handleCloseModal,
          className: "alert-modal__close-btn"
        }, void 0), _jsx("div", __assign({
          className: "alert-modal__container"
        }, {
          children: this.props.children
        }), void 0)]
      }), void 0)
    }, void 0);
  };

  return AlertModal;
}(React.Component);

export function showAlertModal(inner) {
  var root = document.createElement("div");
  document.body.appendChild(root);

  var onModalClose = function onModalClose() {
    ReactDOM.unmountComponentAtNode(root);
    document.body.removeChild(root);
  };

  ReactDOM.render(_jsx(AlertModal, __assign({
    onModalClose: onModalClose
  }, {
    children: inner
  }), void 0), root);
}